module.exports = __webpack_public_path__ + "img/icon-arrow.edf17bda.svg";